import { Controller } from "@hotwired/stimulus"

// Imprimir la página actual. El pack de V2 solo carga controllers/v2/*, así que
// el `qrcode` de V1 no existe acá: esto es su equivalente, con el nombre que
// describe lo que hace (imprimir) y no dónde se usa.
export default class extends Controller {
  print() {
    window.print()
  }
}
